import React from 'react'
import {
  ContentStyled,
  TitleStyled,
  ContainerStyled,
} from '@core/Areas/VenueMode/Components/Racing/RacingTermsAndConditions.styles'
import { RacingMarketType } from '@core/Areas/VenueMode/Components/Racing/Data/types'

export interface RacingTermsAndConditionsProps {
  market: RacingMarketType
}

export const RacingTermsAndConditions: React.FC<RacingTermsAndConditionsProps> = ({ market }) => {
  return (
    <ContainerStyled>
      <ContentStyled>{market.extraRules}</ContentStyled>

      {market.conditions && (
        <>
          <TitleStyled>Betting Conditions</TitleStyled>
          <ContentStyled>{market.conditions}</ContentStyled>
        </>
      )}

      {/* deliberately not displaying 'betting description' because this is currently assigned (via TBS) to the venue when the event is created */}

      {market.rules && (
        <>
          <TitleStyled>Betting Rules</TitleStyled>
          <ContentStyled>{market.rules}</ContentStyled>
        </>
      )}
    </ContainerStyled>
  )
}